import React from "react";
import { twMerge } from "tailwind-merge";
import { formatFirestoreTimestamp, splitCamel } from "../utils/common";
import Preview from "./preview";
import { Timestamp } from "firebase/firestore";
import FighterRecordsTable from "./fighter-records-table";
import { useAuth } from "../contexts/auth-context";
import { useTranslation } from "react-i18next";

const defaultOrder = [
    "fighterPicture",
    "email",
    "name"
]

export function ProfileTable() {
    const { currentUser } = useAuth();
    const { t } = useTranslation();
    const fighter = currentUser.fighter;
    const whiteList =[
        "fighterPicture",
        "email",
        "name",
        "gender",
        "weightClass",
        "height",
        "birthdate",
        "age",
        "nationality",
        "phoneNumber",
        "emergencyContactNumber",
        "icOrPassport",
        "igUsername",
        "gymNameOrTeamName",
        "walkOutMusic",
        "createdAt",
        "records",
        "updateAt"
    ]

    const getDisplayValue = (key, value) => {
        if (!whiteList.includes(key)) return null;
        if (!value) return t('profile.empty');

        switch (key) {
            case "fighterPicture":
            case "receipt":
                return <Preview className={key === "fighterPicture" && "h-[12rem] overflow-hidden object-center object-contain"} src={value} />;

            case "birthdate":
                return formatFirestoreTimestamp(value);

            case "gender":
                return value === "M" ? t('profile.gender.male') : value === "F" ? t('profile.gender.female') : t('profile.gender.unknown');

            case "records":
                return <FighterRecordsTable records={value} />;

            case "weightClass":
                return t(`fighterEdit.fields.weightClass.classes.${value}`);
            case "createdAt":
            case "updateAt":
                return formatFirestoreTimestamp(value);
            default:
                return `${value}`;
        }
    };

    const getLocalizedKey = (key) => {
        if (!whiteList.includes(key)) return null;
        switch (key) {
            case "fighterPicture":
                return t('profile.fields.profilePicture');
            case "email":
                return t('profile.fields.email');
            case "name":
                return t('profile.fields.fullName');
            case "gender":
                return t('profile.fields.gender');
            case "birthdate":
                return t('profile.fields.dateOfBirth');
            case "age":
                return t('profile.fields.age');
            case "height":
                return t('profile.fields.height');
            case "weightClass":
                return t('profile.fields.weightClass');
            case "nationality":
                return t('profile.fields.nationality');
            case "icOrPassport":
                return t('profile.fields.idPassport');
            case "phoneNumber":
                return t('profile.fields.phoneNumber');
            case "emergencyContactNumber":
                return t('profile.fields.emergencyContact');
            case "igUsername":
                return t('profile.fields.instagram');
            case "gymNameOrTeamName":
                return t('profile.fields.gymTeam');
            case "walkOutMusic":
                return t('profile.fields.walkoutMusic');
            case "records":
                return t('profile.fields.records');
            case "createdAt":
                return t('profile.fields.createdAt');
            case "updateAt":
                return t('profile.fields.updateAt');
            default:
                return splitCamel(key) ?? "?";
        }
    };

    return (
        <div className='flex flex-col w-full gap-6'>
            <div className='flex flex-col md:flex-row gap-2 items-start md:items-center border-b pb-2 hidden md:flex'>
                <p className='font-bold min-w-[250px]'>{t('profile.fields.name')}</p>
                <p className='font-bold w-full'>{t('profile.fields.value')}</p>
            </div>

            {[...defaultOrder, ...Object.keys(fighter).filter((k) => !defaultOrder.includes(k) && whiteList.includes(k))].map((key, index) => {
                const value = fighter[key];
                return (
                    <div key={index} className='flex flex-col md:flex-row gap-2 items-start md:items-center'>
                        <p className='font-normal min-w-[250px] text-nowrap'>
                            {getLocalizedKey(key)}
                        </p>
                        <div className={twMerge('font-semibold w-full overflow-auto')}>
                            {getDisplayValue(key, value)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

